import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FinePrintService } from '@tdwb/core';
import { AgreementsCegFinePrintComponent } from './agreements-ceg-fine-print.component';
import { AgreementsNyseFinePrintComponent } from './agreements-nyse-fine-print.component';
import { AgreementsNasdaqFinePrintComponent } from './agreements-nasdaq-fine-print.component';

/**
 * AgreementsFinePrintComponent
 * Reusable component for agreements fine print
 */
@Component({
  selector: 'td-wb-agreements-fine-print',
  templateUrl: 'agreements-fine-print.component.html',
  styleUrls: ['agreements-fine-print.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AgreementsFinePrintComponent implements OnInit, OnDestroy {
  constructor(private finePrintService: FinePrintService) {
  }

  ngOnInit(): void {
    this.finePrintService.setNamespace('tdWb.platform.preferences.agreements.fineprints');
    this.finePrintService.setFinePrints({
      customs: [
        { content: AgreementsCegFinePrintComponent },
        { content: AgreementsNyseFinePrintComponent },
        { content: AgreementsNasdaqFinePrintComponent }
      ]
    });
  }

  ngOnDestroy(): void {
    this.finePrintService.clearFinePrints();
  }
}
